module.exports = __webpack_public_path__ + "img/logo_grupovia_white.921b11aa.png";